import React from "react"
import "./mobile-navigation.css"
import FontAwesome from "react-fontawesome";
import { Link } from "gatsby"

export default class MobileNavigation extends React.Component {
  getClass(menuIsOpen) {
    if (menuIsOpen) {
      return "mobile-navigation mobile-navigation--open"
    } else {
      return "mobile-navigation"
    }
  }
  render() {
    return (
      <nav className={this.getClass(this.props.menuIsOpen)}>
        <ul className="mobile-navigation__items">
          <li>
            <Link to="/tech-check" onClick={this.props.updateState}><FontAwesome className="fas fa-check" name="" style={{marginRight: '15px', opacity: '.7'}}/>  Techcheck</Link>
          </li>
          <li>
            <Link to="/full-check" onClick={this.props.updateState}><FontAwesome className="fas fa-check-double" name="" style={{marginRight: '15px', opacity: '.7'}}/>  Fullcheck</Link>
          </li>
          <li>
            <Link to="/contact" onClick={this.props.updateState}><FontAwesome className="fas fa-paper-plane" name="" style={{marginRight: '15px', opacity: '.7'}}/>  Contact</Link>
          </li>
        </ul>
      </nav>
    )
  }
}
